
import * as React from "react";

export const CoatOfArms = (data) => {
    if (!data.emblem) {
        return null;
    }

    const [shieldId, shieldColor, emblemId, emblemColor] = data.emblem.split("#");

    return <div className={`coatOfArms_wrapper ${data.size}`} {...data.style && { style: data.style }}>
        <div className="border_wrapper">
            <img src={require(`../../../assets/images/misc/not_found.png`).default}/>
        </div>
        <div className="shield_wrapper">
            <img src={require(`../../../assets/images/misc/not_found.png`).default} style={{
                filter: `opacity(0.5) drop-shadow(0 0 0 #${shieldColor}) drop-shadow(0 0 0 #${shieldColor}) drop-shadow(0 0 0 #${shieldColor}) drop-shadow(0 0 0 #${shieldColor}) drop-shadow(0 0 0 #${shieldColor})`
            }}/>
        </div>
        <div className="emblem_wrapper">
            <img src={require(`../../../assets/images/misc/not_found.png`).default} style={{
                filter: `opacity(0.2) drop-shadow(0 0 0 #${emblemColor}) drop-shadow(0 0 0 #${emblemColor}) drop-shadow(0 0 0 #${emblemColor}) drop-shadow(0 0 0 #${emblemColor}) drop-shadow(0 0 0 #${emblemColor})`
            }}/>
        </div>
    </div>
}
